import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { LimiteProduitDTO } from '../model/limiteproduit/limite-produit-dto';
import { UpdateLimiteProduit } from '../model/limiteproduit/update-limite-produit';
import { CreateLimiteProduit } from '../model/limiteproduit/create-limite-produit';

@Injectable({
    providedIn: 'root'
  })
  export class LimiteProduitService{
  
    constructor(private _restClientService : RestClientService) 
    {}

    findAllByProduitId(produitId) 
    {
        return this._restClientService.load<LimiteProduitDTO[]>('limite-produit/find-all-by-produit?produitid='+produitId);
    }
   
    findAll() 
    {
        return this._restClientService.load<LimiteProduitDTO[]>('limite-produit/find-all');
    }
        
    findById(id) 
    {
        return this._restClientService.load<LimiteProduitDTO>('limite-produit/find-by-id/'+id);
    }
    
    update(updateLimiteProduit: UpdateLimiteProduit ) 
    {
        return this._restClientService.put<UpdateLimiteProduit>('limite-produit/update', updateLimiteProduit);
    }
    
    add(createLimiteProduit: CreateLimiteProduit ) 
    {
        return  this._restClientService.save<CreateLimiteProduit>('limite-produit/add', createLimiteProduit);
    }
     
    delete(id) 
    {
        return this._restClientService.delete<any>('limite-produit/delete/'+id);
    }
  




}      

    